<script setup>
defineProps({ proof: { type: Object, required: true } })
const timeLabel = value => value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '尚未取得'
</script>

<template>
  <section class="publication-data" aria-label="公开发布核验与效果数据">
    <p><strong>公开发布核验：</strong>{{ proof.public_check?.label || '等待核验' }}</p>
    <small v-if="proof.public_check?.observed_at">核验时间：{{ timeLabel(proof.public_check.observed_at) }}</small>
    <p v-if="['unknown', 'private'].includes(proof.public_check?.status)">公开页面暂时无法核实，原链接已保留。可等待补查，或打开贴文后人工确认。</p>
    <p v-if="proof.public_check?.status === 'observed'">已发现具体贴文。发布人归属和任务审核仍由项目经理确认。</p>
    <article v-for="snapshot in proof.data_snapshots || []" :key="snapshot.window_days" class="data-snapshot">
      <strong>{{ snapshot.window_days === 0 ? '发布后' : `第 ${snapshot.window_days} 天` }} · {{ snapshot.label }}</strong>
      <small>数据时间：{{ timeLabel(snapshot.observed_at) }}；指标均为平台累计值。</small>
      <div class="metric-list">
        <span v-for="(metric, name) in snapshot.metrics || {}" :key="name">
          {{ metric.definition }}：{{ metric.value === null ? '平台未提供' : `${metric.approximate ? '约 ' : ''}${metric.value}` }}
        </span>
      </div>
      <details v-if="snapshot.comments_obtained !== undefined">
        <summary>已取得 {{ snapshot.comments_obtained }} 条顶层评论 · {{ snapshot.comments_complete ? '本次翻页结束' : '部分样本' }}</summary>
        <p v-for="comment in snapshot.comments || []" :key="comment.id">{{ comment.text }}</p>
        <p v-if="!snapshot.comments?.length">本次接口返回无评论。</p>
      </details>
    </article>
  </section>
</template>

<style scoped>
.publication-data{display:grid;gap:7px;padding:12px;background:#f2faf9;border:1px solid #d7ece7;border-radius:9px;color:#244c50}
.publication-data p{margin:0;overflow-wrap:anywhere}.publication-data small{color:#61767b}.data-snapshot{display:grid;gap:7px;padding-top:9px;border-top:1px solid #d7ece7}
.metric-list{display:flex;flex-wrap:wrap;gap:8px}.metric-list span{padding:4px 7px;background:#fff;border-radius:5px}details p{margin:7px 0!important}details[open]{max-height:260px;overflow:auto}
</style>
